var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.167,
    height: 15.597,
    viewBox: "0 0 20.167 15.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "film-roll",
    transform: "translate(0 -58.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(7.633 62.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M193.779,336.505h0Z",
    transform: "translate(-193.779 -330.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M193.78,175.494v6.342l5.492-3.171Zm1.182,2.047,1.947,1.124-1.947,1.124Z",
    transform: "translate(-193.78 -175.494)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(0 58.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M18.985,58.01v1.078H17.347V58.01H16.165v2.558H4V58.01H2.82v1.078H1.182V58.01H0v15.6H1.182V72.08H2.82v1.527H4V71.05H16.165v2.558h1.182V72.08h1.639v1.527h1.182V58.01ZM2.82,70.9H1.182V69.127H2.82Zm0-2.953H1.182V66.175H2.82Zm0-2.953H1.182V63.222H2.82Zm0-2.953H1.182V60.27H2.82Zm13.345,7.827H4V61.749H16.165Zm2.82,1.03H17.347V69.127h1.639Zm0-2.953H17.347V66.175h1.639Zm0-2.953H17.347V63.222h1.639Zm0-2.953H17.347V60.27h1.639Z",
    transform: "translate(0 -58.01)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRender);
export default __webpack_public_path__ + "static/media/icon-render.a934f604bb95ce377c9eb30d2e4a02ec.svg";
export { ForwardRef as ReactComponent };